<template>
  <div>
    <v-container style="max-width: 1000px">
      <h3 class="headline">{{ $t('Payment Method') }}</h3>

      <v-layout wrap>
        <v-flex xs9>
          <p class="title">
            {{ $t('Bank Transfer') }}
            <template v-if="allowToEdit">
              <input-boolean-no-label
                v-model="contents.allowtransfer"
                @onInputChange="isTransfer = !isTransfer"
              ></input-boolean-no-label>
            </template>
          </p>
        </v-flex>
        <v-flex v-if="allowToEdit" xs3 class="text-xs-right">
          <v-btn
            v-if="!isEditTransfer"
            fab
            outline
            small
            color="primary"
            @click="isEditTransfer = true"
          >
            <em class="fa fa-pencil-alt middle" />
          </v-btn>
        </v-flex>
      </v-layout>
      <transfer-payment
        :is-edit="isEditTransfer"
        :init="contents"
        @onSave="isEditTransfer = false"
      ></transfer-payment>
    </v-container>

    <template v-if="allowToEdit">
      <v-divider></v-divider>
      <v-container style="max-width: 1000px">
        <p class="title">
          {{ $t('Credit card') }}
          <template v-if="selectedBot.paypal_merchantid != null">
            <input-boolean-no-label
              v-model="contents.allowcreditcard"
              @onInputChange="isCreditCard = !isCreditCard"
            ></input-boolean-no-label>
          </template>
        </p>
        <div>
          <div v-if="selectedBot.paypal_merchantid != null">
            {{ $t('Connected with PayPal merchant id') }}:
            <p class="small primary-color">{{ selectedBot.paypal_merchantid }}</p>
          </div>

          <div v-show="!selectedBot.paypal_merchantid">
            <div v-show="!paypal.haveTrackingId">
              <p>{{ $t('to activate credit card payment, please click Link PayPal Account') }}</p>
              <p class="small" style="font-size: 12px">
                {{
                  $t(
                    '(Accept credit/debit card through Paypal channel, with only 3.4% fee for domestic transaction, withdraw to your bank account in 3-5 days)'
                  )
                }}
              </p>
              <div v-show="!paypal.loading">
                <div>
                  <div style="display: flex">
                    <div
                      style="
                        cursor: pointer;
                        display: table-cell;
                        vertical-align: middle;
                        background: white;
                        overflow: auto;
                        border: 1px solid #b1aeae;
                        border-right: 0;
                        border-top-left-radius: 5px;
                        border-bottom-left-radius: 5px;
                      "
                      @click="registerPaypalMerchant"
                    >
                      <img
                        src="https://www.paypalobjects.com/webstatic/en_US/i/buttons/PP_logo_h_100x26.png"
                        alt
                        style="padding: 10px 10px; background: #fff; width: 100%"
                      />
                    </div>
                    <div
                      style="
                        cursor: pointer;
                        background: #002f86;
                        border: 1px solid #b1aeae;
                        border-left: 0;
                        border-top-right-radius: 5px;
                        border-bottom-right-radius: 5px;
                      "
                      @click="registerPaypalMerchant"
                    >
                      <p
                        style="
                          padding: 15px 15px;
                          margin: 0;
                          max-width: 180px;
                          color: white;
                          white-space: nowrap;
                        "
                      >
                        {{ $t('Link PayPal Account') }}
                      </p>
                    </div>
                  </div>
                  <a
                    href="javascript:void(0);"
                    style="vertical-align: top; display: inline-block; margin-top: 14px"
                    @click="showHelpRegisterPaypal = true"
                    >{{ $t('how to link PayPal Account?') }}</a
                  >
                </div>
              </div>

              <div v-show="paypal.loading">
                <sync-loader
                  :color="$vuetify.theme.primary"
                  :size="'10px'"
                  style="display: inline-block; margin-right: 10px; margin-bottom: 15px"
                ></sync-loader>
                {{ $t('Loading') }}
              </div>
            </div>
            <div v-show="paypal.haveTrackingId">
              <div style="margin-bottom: 15px">
                <template v-if="paypal.checkTracking">
                  <sync-loader
                    :color="$vuetify.theme.primary"
                    :size="'10px'"
                    style="display: inline-block; margin-right: 10px"
                  ></sync-loader>
                  <span style="display: inline">{{
                    $t('Pending PayPal Merchant Account Registration')
                  }}</span>
                </template>
                <template v-else>
                  <a href="javascript:void(0);" @click="onRefreshTrackingStatus">
                    <em class="fas fa-sync-alt" />
                    {{ $t('Click refresh after you have completed registration') }}
                  </a>
                </template>
                |
                <a href="javascript:void(0);" @click="cancelRegisterPaypalMerchant">{{
                  $t('cancel')
                }}</a>
              </div>
            </div>

            <modal-dialog v-if="showHelpRegisterPaypal" @close="showHelpRegisterPaypal = false">
              <span slot="header"></span>

              <div slot="body">
                <h1 class="text-xs-center">{{ $t('How to link PayPal Account') }}</h1>
                <div style="margin-top: 15px; margin-bottom: 25px; text-align: center">
                  <p style="padding: 0 15px">{{ $t('1. Click Link PayPal Account button') }}</p>
                  <img
                    src="/static/img/assets/setting/register_paypal/step1.png"
                    style="width: 100%; margin: auto"
                    alt
                  />
                </div>
                <div class="hr"></div>
                <div style="margin-top: 15px; margin-bottom: 25px; text-align: center">
                  <p style="padding: 0 15px">
                    {{ $t('2. input email and select Thailand and then click on Next button') }}
                  </p>
                  <img
                    src="/static/img/assets/setting/register_paypal/step2.png"
                    style="width: 100%; margin: auto"
                    alt
                  />
                </div>
                <div class="hr"></div>
                <div style="margin-top: 15px; margin-bottom: 25px; text-align: center">
                  <p style="padding: 0 15px">
                    {{ $t('3. complete details in form (select Thailand, and THB only)') }}
                  </p>
                  <img
                    src="/static/img/assets/setting/register_paypal/step3.png"
                    style="width: 100%; margin: auto"
                    alt
                  />
                </div>
                <div class="hr"></div>
                <div style="margin-top: 15px; margin-bottom: 25px; text-align: center">
                  <p style="padding: 0 15px">
                    {{ $t('4. Accept to connect with Robolingo Co., Ltd.') }}
                  </p>
                  <img
                    src="/static/img/assets/setting/register_paypal/step4.png"
                    style="width: 100%; margin: auto"
                    alt
                  />
                </div>
                <div class="hr"></div>
                <div style="margin-top: 15px; margin-bottom: 25px; text-align: center">
                  <p style="padding: 0 15px">
                    {{ $t('5. verify e-mail and click ใช่ นี่คือที่อยู่อีเมลของฉัน button') }}
                  </p>
                  <img
                    src="/static/img/assets/setting/register_paypal/step4_1.png"
                    style="width: 100%; margin: auto"
                    alt
                  />
                </div>
                <div class="hr"></div>
                <div style="margin-top: 15px; margin-bottom: 25px; text-align: center">
                  <p style="padding: 0 15px">
                    {{
                      $t(
                        '6. Wait for processing and click Try to get PayPal merchant id again button to check connection with PayPal'
                      )
                    }}
                  </p>
                  <img
                    src="/static/img/assets/setting/register_paypal/step5.png"
                    style="width: 100%; margin: auto"
                    alt
                  />
                </div>
                <div class="hr"></div>
                <div style="margin-top: 15px; margin-bottom: 25px; text-align: center">
                  <p style="padding: 0 15px">
                    {{
                      $t(
                        '7. After you register successfully you will see merchant id on this page. If you can not register, please contact'
                      )
                    }}
                    <a :href="'mailto:' + $store.state.theme.email_contact">{{
                      $store.state.theme.email_contact
                    }}</a>
                  </p>
                  <img
                    src="/static/img/assets/setting/register_paypal/step6.png"
                    style="max-width: 300px; width: 100%; margin: auto"
                    alt
                  />
                </div>
              </div>

              <div slot="footer">
                <div class="row text-xs-center">
                  <a
                    href="javascript:void(0);"
                    class="btn btn-primary"
                    @click="showHelpRegisterPaypal = false"
                    >{{ $t('cancel') }}</a
                  >
                </div>
              </div>
            </modal-dialog>
          </div>
        </div>
      </v-container>
    </template>
    <v-divider></v-divider>
    <template v-if="selectedBot.pagetype != 'enterprise'">
      <v-container style="max-width: 1000px">
        <fbpay-payment class="my-5"></fbpay-payment>
      </v-container>
      <v-divider></v-divider>
    </template>

    <template
      v-if="
        selectedBot.pagetype != 'enterprise' ||
        $store.state.gbprimetheme.includes(selectedBot.theme) ||
        isActiveGbPrime
      "
    >
      <v-container style="max-width: 1000px">
        <gbprime-payment class="my-5"></gbprime-payment>
      </v-container>
      <v-divider></v-divider>
    </template>

    <v-container style="max-width: 1000px">
      <v-layout wrap>
        <v-flex xs9>
          <h3 class="headline">{{ $t('Profile') }}</h3>
        </v-flex>
        <v-flex xs3 class="text-xs-right">
          <v-btn v-if="!isEditShop" fab outline small color="primary" @click="isEditShop = true">
            <em class="fa fa-pencil-alt middle" />
          </v-btn>
        </v-flex>
      </v-layout>
      <shop-profile
        :is-edit="isEditShop"
        :show-address="true"
        @onSave="isEditShop = false"
      ></shop-profile>
    </v-container>
    <v-divider></v-divider>

    <PaymentMessageAfterSummary />
    <v-divider></v-divider>

    <v-container style="max-width: 1000px"> </v-container>

    <div class="mb-5 mt-5"></div>
  </div>
</template>

<script>
import TransferPayment from '@/components/view/setting/ecommerce/TransferPayment'
import InputBooleanNoLabel from '@/components/view/setting/input-no-label/InputBooleanNoLabel'

import api from '@/api'
import ModalDialog from '@/components/elements/ModalDialog'
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'
import { mapGetters } from 'vuex'

import Multiselect from 'vue-multiselect'
import Swatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.min.css'

import ShopProfile from '@/components/view/setting/ecommerce/ShopProfile'
import FbpayPayment from './FbpayPayment'
import GbprimePayment from './GbprimePayment'

import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import PaymentMessageAfterSummary from './PaymentMessageAfterSummary'
import { PAGE } from '@/constants/page.js'

export default {
  components: {
    InputBooleanNoLabel,
    TransferPayment,
    SyncLoader,
    ModalDialog,
    Swatches,
    Multiselect,
    ScaleLoader,
    ShopProfile,
    FbpayPayment,
    GbprimePayment,
    PaymentMessageAfterSummary
  },
  data: function () {
    return {
      isEditPaymentDetail: false,
      isEditShop: false,
      isEditTransfer: false,
      isEditOrderSummaryMessage: false,
      contents: {},
      isTransfer: false,
      isCreditCard: false,
      paypal: {
        paypal_url: null,
        tracking_id: null,
        loading: true,
        checkTracking: false,
        haveTrackingId: false,

        checkingInterval: null,
        checkingTime: 4,
        checkingTimePerInterval: 5000
      },
      profile: {},
      oldProfile: {},
      showHelpRegisterPaypal: false,
      color: '#1CA085',
      lang: {
        value: 'th',
        flag: 'th',
        label: 'Thai'
      },
      langOptions: [
        {
          value: 'en',
          flag: 'gb',
          label: 'English'
        },
        {
          value: 'th',
          flag: 'th',
          label: 'Thai'
        },
        {
          value: 'la',
          flag: 'la',
          label: 'Laos'
        }
      ],
      wordafter: {
        loading: true,
        wordscartsummary: {
          type: 'text',
          text: ''
        },
        wordsorders: {
          type: 'text',
          text: ''
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      paypalTrackingId: 'paypalTrackingId',
      currentLang: 'currentLang'
    }),
    allowToEdit() {
      return (
        this.selectedBot &&
        ((this.$store.state.nestlePages.some((page) => page.pageid == this.selectedBot.pageid) &&
          this.$store.state.userid == 'zwizadmin') ||
          !this.$store.state.nestlePages.some((page) => page.pageid == this.selectedBot.pageid))
      )
    },
    isActiveGbPrime() {
      let statusActive = false
      if (
        ['runkan', 'foodguru', 'cityfresh'].includes(this.selectedBot.theme) ||
        PAGE.TREMENDOUS.includes(this.selectedBot.pageid) ||
        ['Aira'].includes(this.selectedBot.type)
      ) {
        statusActive = true
      }

      return statusActive
    }
  },
  created: function () {
    var vm = this
    vm.paypal.haveTrackingId = vm.paypalTrackingId != null
    vm.paypal.checkTracking = vm.paypal.haveTrackingId && vm.selectedBot.paypal_merchantid == null
    vm.$store.dispatch('loadCharges')
    vm.$store.dispatch('loadSetting')

    vm.getSetting()
    vm.getShopProfile()
    if (vm.$store.state.shoptheme.includes(vm.selectedBot.theme)) {
      vm.$store.dispatch('loadCategory').then(function () {
        vm.$store.dispatch('loadProducts')
      })
      if (vm.selectedBot.paypal_merchantid == null) {
        if (vm.paypalTrackingId == null) {
          vm.getPaypalUrl()
        } else {
          if (vm.paypal.checkTracking) {
            vm.onRefreshTrackingStatus()
          }
        }
      }
    }
  },
  mounted: function () {
    ;(function (d, s, id) {
      var js,
        ref = d.getElementsByTagName(s)[0]
      if (!d.getElementById(id)) {
        js = d.createElement(s)
        js.id = id
        js.async = true
        js.src = 'https://www.paypal.com/webapps/merchantboarding/js/lib/lightbox/partner.js'
        ref.parentNode.insertBefore(js, ref)
      }
    })(document, 'script', 'paypal-js')
  },
  methods: {
    addWordOrderPrefill: function (prefill) {
      var vm = this
      let cursorPosition = vm.$refs.answer_word_orders.$el.selectionStart
      vm.wordafter.wordsorders.text = [
        vm.wordafter.wordsorders.text.slice(0, cursorPosition),
        '{' + prefill + '}',
        vm.wordafter.wordsorders.text.slice(cursorPosition)
      ].join('')
    },
    onSelectLang: function (val) {
      this.lang = val
      this.profile.shoplang = val.value
    },
    getSetting: function () {
      let vm = this
      var data = {
        pageid: vm.selectedBot.pageid
      }

      api.getSetting(data, function (error, response) {
        if (error) {
          console.error(error)
          return
        }
        vm.contents = {}
        if (response.data) {
          response.data.map(function (setting, index) {
            vm.contents[setting.contenttype] = setting
            if (setting.contenttype === 'allowtransfer') {
              vm.isTransfer = setting.contentvalue
            }
            if (setting.contenttype === 'allowcreditcard') {
              vm.isCreditCard = setting.contentvalue
            }
          })
        }
      })
    },
    getShopProfile: function () {
      let data = {
        pageid: this.selectedBot.pageid
      }
      let vm = this
      api.getShopProfile(data, function (error, response) {
        if (error) {
          console.error(error)

          return
        }
        if (response.shopprofile) {
          vm.profile = {
            pageaddress: response.shopprofile.pageaddress,
            description: response.shopprofile.description,
            pageshortlink: response.shopprofile.pageshortlink,
            pagename: response.shopprofile.pagename,
            shoplang: response.shopprofile.shoplang,
            shopcolor: response.shopprofile.shopcolor
          }
          vm.oldProfile = {
            pageaddress: response.shopprofile.pageaddress,
            description: response.shopprofile.description,
            pageshortlink: response.shopprofile.pageshortlink,
            pagename: response.shopprofile.pagename,
            shoplang: response.shopprofile.shoplang,
            shopcolor: response.shopprofile.shopcolor
          }
          var findLang = vm.langOptions.find(function (el) {
            return el.value == response.shopprofile.shoplang
          })

          if (findLang) {
            vm.lang = findLang
          } else {
            vm.lang = vm.langOptions[1]
          }

          vm.color = response.shopprofile.shopcolor ? response.shopprofile.shopcolor : '#1CA085'
        }
      })
    },
    saveProfile: function () {
      let vm = this
      let data = {
        description: vm.profile.description != null ? vm.profile.description : '',
        pageaddress: vm.profile.pageaddress != null ? vm.profile.pageaddress : '',
        pageid: vm.selectedBot.pageid,
        pageshortlink: vm.profile.pageshortlink != null ? vm.profile.pageshortlink : vm.pageid
      }
      if (vm.$store.getters.getPackage == 'premium') {
        data.shoplang = vm.profile.shoplang
        data.shopcolor = vm.color
      }

      vm.$validator.validate().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }
        api.editShopProfile(data, function (error, response) {
          if (error) {
            console.error(error)
            return
          }
          vm.isEditShop = false
          vm.oldProfile.description = vm.profile.description
          vm.oldProfile.pageaddress = vm.profile.pageaddress
          vm.oldProfile.pageshortlink = vm.profile.pageshortlink
        })
      })
    },

    resetPageShortLink: function () {
      if (!this.selectedBot.pageid || this.selectedBot.pageid == null) {
        return false
      }
      this.isChangeShortlink = true
      this.profile.pageshortlink = this.selectedBot.pageid
    },
    cancelEditProfile: function () {
      var vm = this
      this.profile.description = this.oldProfile.description
      this.profile.pageaddress = this.oldProfile.pageaddress
      this.profile.pageshortlink = this.oldProfile.pageshortlink
      var findLang = vm.langOptions.find(function (el) {
        return el.value == vm.oldProfile.shoplang
      })

      if (findLang) {
        vm.lang = findLang
      } else {
        vm.lang = vm.langOptions[1]
      }
      this.isEditShop = false
    },
    getPaypalUrl: function () {
      var vm = this
      vm.paypal.loading = true
      var data = []
      api.getPaypalUrl(data, function (error, response) {
        if (error) {
          console.error(error)
          return
        }
        vm.paypal.paypal_url = response.data.links[1].href
        document.getElementById('actionId').href = vm.paypal.paypal_url + '&displayMode=minibrowser'
        vm.paypal.tracking_id = response.tracking_id
        vm.paypal.loading = false
      })
    },
    registerPaypalMerchant: function () {
      var vm = this

      document.getElementById('actionId').click()

      vm.$store.dispatch('updatePaypalTrackingId', vm.paypal.tracking_id)

      vm.paypal.haveTrackingId = true
      vm.paypal.checkTracking = true
      vm.onRefreshTrackingStatus()
    },
    cancelRegisterPaypalMerchant: function () {
      var vm = this
      if (vm.paypal.checkingInterval != null) {
        clearInterval(vm.paypal.checkingInterval)
      }
      this.getPaypalUrl()
      this.paypal.haveTrackingId = false
      this.paypal.checkTracking = false
      vm.$store.dispatch('updatePaypalTrackingId', null)
    },
    onRefreshTrackingStatus: function () {
      var vm = this
      vm.paypal.checkingTime = 6
      vm.paypal.checkTracking = true

      vm.checkingTrackingStatus(function (status) {
        if (status) {
          clearInterval(vm.paypal.checkingInterval)
          vm.paypal.checkTracking = false
        } else {
          vm.paypal.checkingInterval = setInterval(() => {
            vm.checkingTrackingStatus(function (status) {
              if (vm.paypal.checkingTime === 0 || status) {
                clearInterval(vm.paypal.checkingInterval)
                vm.paypal.checkTracking = false
              }
              vm.paypal.checkingTime--
            })
          }, vm.paypal.checkingTimePerInterval)
        }
      })
    },
    checkingTrackingStatus: function (callback) {
      var vm = this
      var data = {
        tracking_id: vm.paypalTrackingId
      }
      api.getPaypalTrackingStatus(data, function (error, response) {
        if (error) {
          console.error(error)
          return
        }

        if (response.status === 'pending') {
          callback(false)
        } else if (
          response.status === 'success' &&
          response.merchant_id !== '' &&
          response.merchant_id != null
        ) {
          data = {
            pageid: vm.selectedBot.pageid,
            paypal_merchantid: response.merchant_id
          }
          api.updatePaypalMerchantId(data, function (error, response) {
            if (error) {
              console.error(error)
              return
            }
            vm.contents.allowcreditcard.contentvalue = true

            vm.$store.dispatch('updateMerchantId', data.paypal_merchantid)

            callback(true)
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@media only screen and (min-width: 600px) {
  .border-right {
    border-right: 1px solid #eee;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/Payment.vue